import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme)=> ({
    singleItem:{
        marginTop:'2%',
        zIndex:'1'
    },
    brandGrid:{
        marginBottom:'4%'
    }
}));

export default useStyles;